<edit-dialog (action)="signalAction($event)" [title]="'Account Information'" class="flex flex-col">
  <ng-container edit-body class="text-black">
    <div id="_modal-CENTER" class="w-full flex flex-col modal-center">
      <gray-label-wrapper [fieldLabel]="'First Name'" [fieldName]="'first_name'" class="w-full text-black flex items-center">
        <input id="first_name" class="ism-black" type="text" [(ngModel)]="user['first']" autocomplete="given-name" required />
      </gray-label-wrapper>

      <gray-label-wrapper [fieldLabel]="'Last Name'" [fieldName]="'last_name'" class="w-full text-black flex items-center">
        <input id="last_name" class="ism-black" type="text" [(ngModel)]="user['last']" autocomplete="family-name" required />
      </gray-label-wrapper>

      <gray-label-wrapper [fieldLabel]="'Email'" [fieldName]="'email'" class="w-full text-black flex items-center">
        <input id="email" class="ism-black" type="text" [(ngModel)]="user['email']" autocomplete="email" required />
      </gray-label-wrapper>

      @if (asAdmin) {
        <gray-label-wrapper [fieldLabel]="'Role'" [fieldName]="'role'" class="w-full text-black flex items-center">
          <div class="flex items-center justify-start">
            <!--  -->
            <div class="mr-2 flex items-center">
              <input id="player" class="form-radio" type="radio" name="roleSelect" value="Player" [(ngModel)]="user['role']" />
              <label for="player" class="mx-1 text-left">Player</label>
            </div>
            <!--  -->
            <div class="mx-2 flex items-center">
              <input id="marshal" class="form-radio" type="radio" name="roleSelect" value="Marshal" [(ngModel)]="user['role']" />
              <label for="marshal" class="mx-1 text-left text-nowrap">Sky Marshal</label>
            </div>
            <!--  -->
            <div class="mx-2 flex items-center">
              <input id="master" class="form-radio" type="radio" name="roleSelect" value="Master" [(ngModel)]="user['role']" />
              <label for="master" class="mx-1 text-left">Master</label>
            </div>
            <!--  -->
            <div class="mx-2 flex items-center">
              <input id="none" class="form-radio" type="radio" name="roleSelect" value="NONE" disabled [(ngModel)]="user['role']" />
              <label for="none" class="mx-1 text-left">None</label>
            </div>
          </div>
        </gray-label-wrapper>
      }

      @if (!(asAdmin && thisIsMe)) {
        <div class="w-full text-black flex flex-col items-center justify-center">
          <hr class="my-4 w-full ism-black" />
          <div class="">Original password must validate and new password fields must match!</div>
          <div class="">Password must validate to be included in the save</div>
        </div>
      }

      @if (!asAdmin) {
        <gray-label-wrapper [fieldLabel]="'Original Password'" [fieldName]="'old_password'" class="w-full text-black flex items-center">
          <div class="flex items-center justify-between">
            <input id="old_password" class="ism-black" type="password" [(ngModel)]="user['oldPassword']" required />
            <reveal-password [theInputId]="'old_password'"></reveal-password>
          </div>
        </gray-label-wrapper>
      }

      @if (!(asAdmin && thisIsMe)) {
        <gray-label-wrapper [fieldLabel]="'Password'" [fieldName]="'newPassword'" class="w-full text-black flex items-center">
          <div class="flex items-center justify-between">
            <input id="inputPwd" #pass1="ngModel" class="ism-black" type="password" [(ngModel)]="user['password']" required minlength="6" />
            <reveal-password [theInputId]="'inputPwd'"></reveal-password>
          </div>
        </gray-label-wrapper>

        <gray-label-wrapper [fieldLabel]="'Repeat Password'" [fieldName]="'password2'" class="w-full text-black flex items-center">
          <div class="flex items-center justify-between">
            <input id="inputPwd2" #pass2="ngModel" class="ism-black" type="password" [(ngModel)]="user['password2']" required />
            <reveal-password [theInputId]="'inputPwd2'"></reveal-password>
          </div>
        </gray-label-wrapper>

        <div class="w-full flex items-center justify-center">
          @let match = user["password2"] === user["password"];
          @let valid = pass1.valid && match;
          @if (!valid) {
            <div class="text-red-600">Passwords do not match</div>
          } @else {
            <div class="text-green-600">Passwords match</div>
          }
        </div>
      }
    </div>
  </ng-container>
</edit-dialog>
